import { FAILURE, REQUEST, SUCCESS, updateObject, createReducer } from 'Stores'
import { GET_BREAD, GET_DRIVES_HOT_LOAD,
  GET_FILES_T0_DOWNLOAD_FOLDER, GET_ONE_DRIVE, GET_ONE_DRIVE_AND_BREAD,
  GET_ONE_DRIVE_FOLDER_MOVE, GET_PORTFOLIO, REMOVE_FILES_T0_DOWNLOAD_FOLDER } from './constants'

export const initialState = {
  isLoading: false,
  error: null,
  listOneDrive: [],
  listFolderMove: [],
  searchDrive: '',
  topLoad: 10,
  portfolioData: null,
  listBread: [],
  listFilesToDownload: [],
  idParentMove: null
}

function getOneDrive(state, { payload }) {
  const { search } = payload
  return updateObject(state, {
    isLoading: true,
    searchDrive: search
  })
}

function getOneDriveSuccess(state, { payload }) {
  const { listOneDrive, topLoad } = payload
  return updateObject(state, {
    isLoading: false,
    listOneDrive,
    topLoad
  })
}

function getOneDriveAndBreadSuccess(state, { payload }) {
  const { listOneDrive, topLoad } = payload
  return updateObject(state, {
    isLoading: false,
    listOneDrive,
    topLoad
  })
}

function getFolderMoveOneDriveSuccess(state, { payload }) {
  const { listFolderMove, idParentMove } = payload
  return updateObject(state, {
    isLoading: false,
    listFolderMove,
    idParentMove
  })
}

function getOneDriveFail(state, error) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function getDriveHotLoadSuccess(state, { payload }) {
  const { topLoad, listOneDrive } = payload
  if (listOneDrive?.length === state.listOneDrive?.length) {
    return updateObject(state, {
      isLoading: false,
      listOneDrive
    })
  }
  return updateObject(state, {
    isLoading: false,
    listOneDrive,
    topLoad
  })
}

function getPortfolioSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    portfolioData: payload
  })
}

function getBreadSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    listBread: payload
  })
}

function getFilesToDownloadFolderSuccess(state, { payload }) {
  const { listFilesToDownload } = payload
  return updateObject(state, {
    isLoading: false,
    listFilesToDownload
  })
}

function removeFilesToDownloadFolderSuccess(state) {
  return updateObject(state, {
    isLoading: false,
    listFilesToDownload: []
  })
}

export default createReducer(initialState, {
  [REQUEST(GET_ONE_DRIVE)]: getOneDrive,
  [SUCCESS(GET_ONE_DRIVE)]: getOneDriveSuccess,
  [SUCCESS(GET_ONE_DRIVE_AND_BREAD)]: getOneDriveAndBreadSuccess,
  [SUCCESS(GET_ONE_DRIVE_FOLDER_MOVE)]: getFolderMoveOneDriveSuccess,
  [FAILURE(GET_ONE_DRIVE)]: getOneDriveFail,
  [SUCCESS(GET_DRIVES_HOT_LOAD)]: getDriveHotLoadSuccess,
  [SUCCESS(GET_PORTFOLIO)]: getPortfolioSuccess,
  [SUCCESS(GET_BREAD)]: getBreadSuccess,
  [SUCCESS(GET_FILES_T0_DOWNLOAD_FOLDER)]: getFilesToDownloadFolderSuccess,
  [SUCCESS(REMOVE_FILES_T0_DOWNLOAD_FOLDER)]: removeFilesToDownloadFolderSuccess
})
